export default __webpack_public_path__ + "static/media/AllThatApply.4e28864d.svg";